/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from '../actions/auth'

const state = {
  token: window.localStorage.getItem('token') || '',
  timefix: window.localStorage.getItem('timefix') || '',
  welcome: window.localStorage.getItem('welcome') || '',
  avatar: window.localStorage.getItem('avatar') || '',
  roles: JSON.parse(window.localStorage.getItem('roles')) || '',
  usuario: JSON.parse(window.localStorage.getItem('usuario')) || '',
  status: '',
  hasLoadedOnce: false
}

const getters = {
  isAuthenticated: state => !!state.token,
  token: state => state.token,
  timefix: state => state.timefix,
  welcome: state => state.welcome,
  avatar: state => state.avatar,
  roles: state => state.roles,
  usuario: state => state.usuario,
  authStatus: state => state.status
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      window.localStorage.setItem('token', user.token)
      window.localStorage.setItem('timefix', user.timefix)
      window.localStorage.setItem('welcome', user.welcome)
      window.localStorage.setItem('avatar', user.avatar)
      window.localStorage.setItem('roles', JSON.stringify(user.roles))
      window.localStorage.setItem('usuario', JSON.stringify(user.usuario))

      commit(AUTH_SUCCESS, user)
      resolve(user)
    })
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('timefix')
      window.localStorage.removeItem('welcome')
      window.localStorage.removeItem('avatar')
      window.localStorage.removeItem('roles')
      window.localStorage.removeItem('usuario')
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, user) => {
    state.status = 'success'
    state.token = user.token
    state.timefix = user.timefix
    state.welcome = user.welcome
    state.avatar = user.avatar
    state.roles = user.roles
    state.usuario = user.usuario
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: state => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    state.timefix = ''
    state.welcome = ''
    state.avatar = ''
    state.token = ''
    state.roles = ''
    state.usuario = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js